module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageTitle"
  }, [_c('div', {
    staticClass: "main"
  }, [(_vm.showBack) ? _c('a', {
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": _vm.goback
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.3rem",
      "margin-left": "0.3rem"
    },
    attrs: {
      "src": require("../../static/goback.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "initial"
    },
    on: {
      "click": _vm.clickTitle
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), (_vm.showTitleIcon) ? _c('img', {
    attrs: {
      "src": require("../../static/components/pageTitle/arr_down.png")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.RightImgName != '') ? _c('a', {
    staticStyle: {
      "float": "right",
      "margin-right": "0.3rem"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.GoIndex()
      }
    }
  }, [(_vm.RightImgName == 'home') ? _c('img', {
    staticStyle: {
      "width": "0.5rem",
      "padding": "0 0.1rem"
    },
    attrs: {
      "src": require("../../static/err/home.png")
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showRight) ? _c('a', {
    staticClass: "rightGo",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickRight.apply(null, arguments)
      }
    }
  }, [(_vm.rightTitle != '') ? _c('span', [_vm._v(_vm._s(_vm.rightTitle))]) : _c('img', {
    attrs: {
      "src": require("../../static/question.png")
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.bottomExtend) ? _c('div', {
    staticClass: "bottomExtend"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e95f349c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageTitle.vue
// module id = 197
// module chunks = 17 18